<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import { polarizationBounds, polarizationValues } from "@/Common/constants";

    export let polarization: number
    export let disabled = false
    export let onInput: () => void = () => {}

</script>

<div class="grid items-center">
    <SelectSlider class="col-span-3" {...polarizationBounds} {disabled}
        bind:value={polarization}
        on:input={onInput}
    />
    <span class="row-start-2 text-sm text-slate-400 self-start justify-self-start ml-1">{polarizationValues[polarizationBounds.min].ratio}</span>
    <span class="justify-self-center text-center">{polarizationValues[polarization].ratio} - <span class="text-slate-500 text-sm">{polarizationValues[polarization].percent}</span></span>
    <span class="text-sm text-slate-400 self-start justify-self-end mr-1">{polarizationValues[polarizationBounds.max].ratio}</span>
</div>